import _ from 'lodash';
import { call, put, takeEvery } from 'redux-saga/effects';
import { apiServiceAsync } from '../services/apiService';
import { actions, actionTypes } from './modules';
import { actions as sharedRecruitmentActions } from '../shared/recruitment/modules';

// const delay = (ms) => new Promise((r) => setTimeout(r, ms));

const { deleteProfileSuccess, deleteProfileFail, changeProfileStatusSuccess, changeProfileStatusFail } = actions;

function* deleteProfileSaga(action: any): any {
  const { profileId } = action.payload;
  try {
    const { profileId: deletedId } = yield call(apiServiceAsync.deleteRecruitmentProfile, profileId);
    yield put(deleteProfileSuccess(deletedId));
    yield put(sharedRecruitmentActions.loadOwnProfiles());
  } catch (e) {
    yield put(deleteProfileFail());
  }
}

type TStatus = { [status: string]: string };
const statusConversions: { [key: string]: TStatus } = {
  renew: { activationStatus: 'active' },
  activate: { activationStatus: 'active' },
  deactivate: { activationStatus: 'draft' }
};

function* changeProfileStatusSaga(action: any): any {
  const { statusType, profileId } = action.payload;
  const updatedStatus = statusConversions[statusType];
  try {
    yield call(apiServiceAsync.saveCharacterRecruitmentProfile, {
      id: profileId,
      ...updatedStatus
    });

    yield put(sharedRecruitmentActions.loadOwnProfiles());
    yield put(changeProfileStatusSuccess());
  } catch (e) {
    yield put(changeProfileStatusFail());
  }
}

const { DELETE_PROFILE, UPDATE_PROFILE_STATUS } = actionTypes;

function* watchDeleteProfile(): any {
  yield takeEvery(DELETE_PROFILE, deleteProfileSaga);
}
function* watchChangeProfileStatus(): any {
  yield takeEvery(UPDATE_PROFILE_STATUS, changeProfileStatusSaga);
}

export default [watchDeleteProfile(), watchChangeProfileStatus()];
